import {useIntl} from "react-intl";
import React from "react";
import {usePopup} from "../../../UIElements";
import {useSupportBotContext} from "../SupportBotData";
import {useSnackbar} from "../../../Content";
import TopicSelector from "../../../components/TopicSelector/TopicSelector";

const SupportTopicCreator = ({botData, updateBotData, updateNestedData}) => {
    const intl = useIntl()
    const { showPopup } = usePopup()
    const { data: { supportTopicCodes, supportBots }, refreshData } = useSupportBotContext()

    return <button
        className={"new-topic"}
        onClick={()=>{showPopup(
            <SupportTopicSelectorWrapper
                botData={botData}
                updateBotData={updateBotData}
                updateNestedData={updateNestedData}
                supportTopicCodes={supportTopicCodes}
                supportBots={supportBots}
                refreshData={refreshData}
            />, 'full-width')}}>
        + {intl.formatMessage({
        id: 'bot.instructions.addTopic',
        defaultMessage: 'Add Topic',
    })}
    </button>
}

const SupportTopicSelectorWrapper = ({botData, updateBotData, updateNestedData, supportTopicCodes, supportBots, refreshData}) => {
    const intl = useIntl()
    const { hidePopup } = usePopup()
    const {setSnackbarData} = useSnackbar()

    const usedCategories = botData?.supportTopics || []
    const topicData = botData?.topicData || {}

    const isTopicShared = (topicId) => {
        if (!supportBots || !Array.isArray(supportBots)) return false;
        const currentVersionGroup = botData.versionGroup;
        return supportBots.some(bot => {
            if (bot?.config?.versionGroup === currentVersionGroup) return false;
            return bot?.config?.supportTopics?.includes(topicId);
        });
    };

    const onSelect = (topic, newTopicData) => {
        if (usedCategories.includes(topic)) {
            setSnackbarData({
                show: true,
                text: intl.formatMessage({
                    id: 'topic.alreadyInUse',
                    defaultMessage: 'This topic is already selected',
                }),
                state: "info",
                autoHide: true,
            })
            return
        }

        updateBotData("supportTopics", [...usedCategories, topic]);

        if (newTopicData) {
            updateBotData("topicData", { ...topicData, [topic]: newTopicData })
        } else {
            updateBotData("topicData", { ...topicData, [topic]: supportTopicCodes[topic] })
        }

        hidePopup()
    }

    return <TopicSelector
        categoryData={supportTopicCodes}
        selectedTopics={usedCategories}
        onSelect={onSelect}
        onRefresh={refreshData}
        title={intl.formatMessage({
            id: 'bot.instructions.addTopic.header',
            defaultMessage: 'Add New Support Topic for Bot',
        })}
        isTopicShared={isTopicShared}
    />
}

export default SupportTopicCreator
